import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-error-loading-data" }

import { reload } from '@/router'

import GameButton from '../game/basics/GameButton.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseReloadData',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(_ctx.$t('errorLoadingData')), 1),
    _createVNode(GameButton, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(reload)()))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('reloadPage')), 1)
      ]),
      _: 1
    })
  ]))
}
}

})